module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.device) ? _c('div', {
    attrs: {
      "id": "MobileLogin"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loginBox"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputRoomCode),
      expression: "inputRoomCode"
    }],
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.inputRoomCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputRoomCode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.roomExistAndGo) ? _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": 'Game/' + _vm.roomExistAndGo,
      "replace": ""
    }
  }, [_vm._v("連結裝置")]) : _c('button', {
    staticClass: "btn"
  }, [_vm._v("連結裝置")])], 1)]) : _c('div', {
    staticClass: "redirect"
  }, [_c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "alertBox"
  }, [_c('p', {
    staticClass: "text alertType"
  }, [_vm._v("請回首頁")]), _vm._v(" "), _c('p', {
    staticClass: "text alertText"
  }, [_vm._v("重新開始遊戲")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/',
      "replace": ""
    }
  }, [_c('span', [_vm._v("確定")])])], 1)]), _vm._v(" "), (!_vm.device) ? _c('router-link', {
    attrs: {
      "to": '/',
      "replace": ""
    }
  }, [_vm._v("確定")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sceneTitle"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/mobile/title-connect.png",
      "height": "40",
      "width": "131",
      "alt": "連結裝置"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_vm._v("請輸入電腦顯示代碼"), _c('br'), _vm._v("連結電腦進行遊戲")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92e81210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLogin.vue
// module id = 451
// module chunks = 0